import { TaskList as OriginalTaskList } from "@tiptap/extension-list";

export const TaskList = OriginalTaskList.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "flex-1",
      },
    };
  },
});
